import React, { useEffect, useState, createContext, useContext } from 'react';
interface User {
  name: string;
  email: string;
}
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => void;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('mcpguard_user');
      return saved ? JSON.parse(saved) : null;
    }
    return null;
  });
  useEffect(() => {
    if (user) {
      localStorage.setItem('mcpguard_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('mcpguard_user');
    }
  }, [user]);
  const login = (email: string, password: string) => {
    // Mock login - extract name from email
    const name = email.split('@')[0].replace(/[._-]/g, ' ');
    const formattedName = name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    const newUser = {
      name: formattedName,
      email
    };
    setUser(newUser);
  };
  const logout = () => {
    setUser(null);
  };
  return <AuthContext.Provider value={{
    user,
    isAuthenticated: !!user,
    login,
    logout
  }} data-id="element-145">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}